import { IUpdateUIProfileConfigResponse } from 'multirpc-sdk';

import { MultiService } from 'modules/api/MultiService';
import { RequestType, web3Api } from 'store/queries';
import { RootState } from 'store';
import { createNotifyingQueryFn } from 'store/utils/createNotifyingQueryFn';

import { IUserProfileConfig } from '../types';
import {
  getUIProfileConfig,
  selectUIProfileConfig,
} from './getUIProfileConfig';
import { safeStringifyJSON } from '../utils/safeStringifyJSON';

interface IUpdateUIProfileConfigParams extends IUserProfileConfig {
  group?: string;
}

export const {
  endpoints: { updateUIProfileConfig },
  useUpdateUIProfileConfigMutation,
} = web3Api.injectEndpoints({
  endpoints: build => ({
    updateUIProfileConfig: build.mutation<
      IUpdateUIProfileConfigResponse,
      IUpdateUIProfileConfigParams
    >({
      queryFn: createNotifyingQueryFn(async (params, { getState }) => {
        const service = MultiService.getService();

        const state = getState() as RootState;

        const config = selectUIProfileConfig(state, { group: params.group });

        const preparedParams = {
          ...config,
          ...params,
        };

        const response = await service
          .getAccountingGateway()
          .updateUIProfileConfig({
            group: params.group,
            config: safeStringifyJSON(preparedParams),
          });

        return { data: response };
      }),
      onQueryStarted: async (args, { dispatch }) => {
        if ('isWhitelistsBannerHidden' in args) {
          dispatch(
            web3Api.util.updateQueryData(
              getUIProfileConfig.name as never,
              { group: args.group } as never,
              (config: IUserProfileConfig) => {
                config.isWhitelistsBannerHidden = args.isWhitelistsBannerHidden;
              },
            ),
          );
        }

        if ('isRPBannerHidden' in args) {
          dispatch(
            web3Api.util.updateQueryData(
              getUIProfileConfig.name as never,
              undefined as never,
              (config: IUserProfileConfig) => {
                config.isRPBannerHidden = args.isRPBannerHidden;
              },
            ),
          );
        }

        if ('isPromoBannerHidden' in args) {
          dispatch(
            web3Api.util.updateQueryData(
              getUIProfileConfig.name as never,
              undefined as never,
              (config: IUserProfileConfig) => {
                config.isPromoBannerHidden = args.isPromoBannerHidden;
              },
            ),
          );
        }
      },
      invalidatesTags: (_response, _error, { group }) => [
        { type: RequestType.ProfileConfig, group },
      ],
    }),
  }),
});
